<template>
  <div class="bos-pop-input">
    <Input
      :disabled="item.disabled"
      :icon="'ios-search'"
      v-model="displayValue"
      :placeholder="item.placeholder ? item.placeholder : ''"
      class="permConds"
      clearable
      @on-clear="applyTypedValue('')"
      @on-click="handleIconClick"
    />
    <Modal
      v-model="modalVisible"
      :title="`选择-${modalContext.fieldLabel || ''}`"
      width="90"
      titleAlign="left"
      closable
      mask
      :mask-closable="false"
      @on-ok="confirmModal"
      @on-cancel="cancelModal"
    >
      <div class="bos-pop-modal">
        <div class="bos-pop-modal__left">
          <StandList
            v-if="modalContext.tableName"
            ref="bosPopStandList"
            class="bos-pop-stand-list"
            permission-mode
            :permission-table="modalContext.tableName"
            :permission-table-id="modalContext.tableId"
            :permission-conditions="modalContext.permissionConditions"
            @conds-change="handleCondsChange"
          />
        </div>
        <div class="bos-pop-modal__right">
          <div class="conds-title">
            多选结果
            <Tooltip content="多条件间是或者的关系，即取并集的数据" transfer max-width="300">
              <Icon type="ios-information-circle-outline" />
            </Tooltip>
          </div>
          <div class="conds-content">
            <table border="1" align="center" cellpadding="0" cellspacing="0">
              <tbody>
                <tr v-for="(cond, index) in modalContext.permissionConditionsForCombine" :key="index">
                  <td width="20">
                    <Checkbox v-model="cond.isCheck"></Checkbox>
                  </td>
                  <td style="word-break: keep-all; white-space: nowrap;">
                    {{ cond.label }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="conds-footer">
            <Button type="fcdefault" @click="handleDeleteConds(1)">移除选中行</Button>
            <Button type="fcdefault" @click="handleDeleteConds(2)">移除全部</Button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import StandList from '../omsui/view/StandList.vue';
import {
  getDataKey,
  getDisplayKey,
  formatDisplay,
  combineConditions,
  readPermissionConditions,
  buildPermissionConditionsFromIds,
  getDisplayFromConditions,
  normalizeConditionsForRequest,
} from './handleValue';

export default {
  name: 'BosPopInput',
  components: {
    StandList,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    formValue: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modalVisible: false,
      modalContext: {},
      activeItem: null,
    };
  },
  computed: {
    dataKey() {
      return getDataKey(this.item);
    },
    displayKey() {
      return this.item.value || getDisplayKey(this.dataKey);
    },
    displayValue: {
      get() {
        return this.formValue[this.displayKey] || '';
      },
      set(val) {
        this.applyTypedValue(val);
      },
    },
  },
  watch: {
    formValue: {
      handler() {
        this.syncDisplayFromConditions();
      },
      deep: true,
    },
  },
  mounted() {
    this.syncDisplayFromConditions();
  },
  methods: {
    /** 仅在弹窗条件模式下同步展示文案；键入字符串模式不覆盖 */
    syncDisplayFromConditions() {
      const raw = this.formValue[this.dataKey];
      if (typeof raw === 'string') return;
      const display = getDisplayFromConditions(this.formValue, this.dataKey);
      if (display && this.formValue[this.displayKey] !== display) {
        this.$set(this.formValue, this.displayKey, display);
      }
    },
    /** 键入：与弹窗条件互斥，dataKey 存字符串 */
    applyTypedValue(val) {
      // Ark Input 的 on-change 可能传入 InputEvent，此处只接受原始文本
      if (val != null && typeof val === 'object') return;
      const text = val == null ? '' : String(val);
      this.$set(this.formValue, this.displayKey, text);
      this.$set(this.formValue, this.dataKey, text);
      if (Object.prototype.hasOwnProperty.call(this.formValue, `${this.dataKey}__ENAME`)) {
        this.$set(this.formValue, `${this.dataKey}__ENAME`, '');
      }
      if (Object.prototype.hasOwnProperty.call(this.formValue, `${this.dataKey}__CONDS`)) {
        this.$set(this.formValue, `${this.dataKey}__CONDS`, []);
      }
    },
    resolvePermissionConditions() {
      const stored = readPermissionConditions(this.formValue, this.dataKey);
      if (stored && stored.length) {
        return stored;
      }
      // 仅兼容「id + __ENAME」旧结构；普通键入字符串不当作弹窗条件
      const ids = this.formValue[this.dataKey];
      const labels = this.formValue[`${this.dataKey}__ENAME`];
      if (typeof ids === 'string' && ids && labels) {
        return buildPermissionConditionsFromIds(ids, labels);
      }
      return [];
    },
    handleIconClick() {
      if (this.item.disabled) return;
      if (this.item.bosPopModal && this.item.bosPopModal.tableName) {
        this.openModal();
        return;
      }
      const handler = this.item.popClick || this.item.iconclick;
      if (typeof handler === 'function') {
        handler();
      }
    },
    openModal() {
      const item = this.item;
      const modal = item.bosPopModal || {};
      const permissionConditions = this.resolvePermissionConditions();
      this.activeItem = item;
      this.modalContext = {
        fieldLabel: item.label || modal.title || '',
        tableName: modal.tableName,
        tableId: modal.tableId,
        dataKey: this.dataKey,
        permissionConditions,
        permissionConditionsForCombine: combineConditions(permissionConditions),
      };
      this.modalVisible = true;
    },
    handleCondsChange(store) {
      if (!store) return;
      this.modalContext.permissionConditions = store;
      this.modalContext.permissionConditionsForCombine = combineConditions(store);
    },
    handleDeleteConds(arg) {
      if (arg == 1) {
        const indexArr = [];
        const arr = [];
        this.modalContext.permissionConditionsForCombine.forEach(i => i.isCheck && indexArr.push(i._index));
        this.modalContext.permissionConditions.forEach((i, index) => !indexArr.includes(index) && arr.push(i));
        this.modalContext.permissionConditions = arr;
        this.modalContext.permissionConditionsForCombine = this.modalContext.permissionConditionsForCombine.filter(i => !i.isCheck);
      } else {
        this.modalContext.permissionConditions = [];
        this.modalContext.permissionConditionsForCombine = [];
      }
      this.handleCondsChange(this.modalContext.permissionConditions);
    },
    confirmModal() {
      const item = this.activeItem;
      const { permissionConditions } = this.modalContext;
      const display = formatDisplay(combineConditions(permissionConditions || []));

      // 弹窗回显：覆盖键入字符串，dataKey 存条件结构
      this.$set(
        this.formValue,
        this.dataKey,
        normalizeConditionsForRequest(permissionConditions || []),
      );
      this.$set(this.formValue, this.displayKey, display);

      if (item && typeof item.bosPopConfirm === 'function') {
        item.bosPopConfirm({
          dataKey: this.dataKey,
          display,
          permissionConditions,
        });
      }
      this.$emit('confirm', {
        item,
        dataKey: this.dataKey,
        display,
        permissionConditions,
      });
      this.cancelModal();
    },
    cancelModal() {
      this.modalVisible = false;
      this.modalContext = {};
      this.activeItem = null;
    },
  },
};

</script>

<style lang="less">
.bos-pop-input {

  .iconios-search:before {
    content: "\eae1";
  }
}

.bos-pop-modal {
  height: 70vh;
  display: grid;
  grid-template-columns: 1fr 250px;
  grid-gap: 8px;

  &__left,
  &__right {
    border: 1px solid #d8d8d8;
  }

  &__left {
    overflow: hidden;

    .bos-pop-stand-list {
      height: 100%;
    }
  }

  &__right {
    position: relative;

    .conds-title {
      background: var(--b2-color, #f5f7fa);
      color: var(--t-text, #515a6e);
      padding: 8px;
    }

    .conds-content {
      height: calc(70vh - 70px);
      overflow: auto;

      table {
        width: 100%;
        background: #f2f2f2;
        border-collapse: collapse;

        &, td {
          border: none;
        }

        td {
          padding: 2px 0;
        }

        tr {
          border-bottom: 1px solid #d2cfcf;
        }
      }
    }

    .conds-footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
}

</style>
